import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import React from 'react';

class ConfirmationDialog extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { open, title, children, submit, closeDialog, submitLabel, cancelLabel, submitColor, submitDisabled } =
      this.props;

    const actions = [
      <Button key="cancel" variant="outlined" onClick={closeDialog}>
        {cancelLabel}
      </Button>,
      <Button key="submit" variant="contained" color={submitColor} disabled={submitDisabled} onClick={submit}>
        {submitLabel}
      </Button>,
    ];

    return (
      <Dialog open={open} onClose={closeDialog}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent dividers>{children}</DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

ConfirmationDialog.defaultProps = {
  submitLabel: 'Submit',
  cancelLabel: 'Cancel',
  submitColor: 'primary',
  submitDisabled: false,
};

export default ConfirmationDialog;
